import { useCallback, useState } from "react";
import { buildImageReadApiUrl } from "../api/favourites";
import { toCdnMediaUrl } from "../utils/cdnMediaUrl";

/**
 * Fast gallery thumbnails:
 * - Prefer direct CloudFront URL in <img> (no API proxy hop; img tags don't need CORS)
 * - Native lazy load + async decode
 * - Soft placeholder until painted
 * - Fall back to image-processing proxy only if CDN fails
 */
function GalleryCardArt({ imageUrl, alt = "", priority = false }) {
  const cdnSrc = toCdnMediaUrl(imageUrl) || String(imageUrl || "").trim();
  const proxySrc = buildImageReadApiUrl(imageUrl) || cdnSrc;
  const [src, setSrc] = useState(cdnSrc);
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  const handleError = useCallback(() => {
    if (src !== proxySrc && proxySrc) {
      setSrc(proxySrc);
      setLoaded(false);
      return;
    }
    setFailed(true);
  }, [proxySrc, src]);

  if (!cdnSrc || failed) {
    return (
      <div className="galleryCard__art galleryCard__art--empty" aria-hidden="true" />
    );
  }

  return (
    <div
      className={`galleryCard__art${loaded ? " is-loaded" : " is-loading"}`}
    >
      <img
        src={src}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        fetchPriority={priority ? "high" : "low"}
        onLoad={() => setLoaded(true)}
        onError={handleError}
      />
    </div>
  );
}

export default GalleryCardArt;
